import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, formatDateTime} from '../../Univ.js'
function OtList() {
    const [ipViewData, setIpViewData] = useState([]);
    useEffect(() => {
        fetchIpViewData();
    }, []);
    function fetchIpViewData() {
        const url = `${baseUrl}surgery-create/`;
        axios.get(url)
            .then(response => {
                const status = (response.data[0].status);
                if (status == 1) {
                    setIpViewData(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'ip_id',
            headerName: 'IP ID',
            width: 120,
            renderCell: (params) => {
                return params.row.ip?.ip_id || '';
            },
        },
        {
            field: 'pat_id',
            headerName: 'Pat ID',
            width: 80,
            renderCell: (params) => {
                return params.row.ip?.pat?.pat_id || '';
            },
        },
        {
            field: 'patient',
            headerName: 'Patient',
            width: 120,
            renderCell: (params) => {
                return params.row.ip?.pat?.patient || '';
            },
        },
        {
            field: 'surg_time',
            headerName: 'Surgery Time',
            width: 180,
            renderCell: (params) => {
                return formatDateTime(params.row.surg_time);
            },
        },
        {
            field: 'ot_type',
            headerName: 'Surgery Type',
            width: 180,
            renderCell: (params) => {
                return params.row.ot_type?.type || '';
            },
        },
        {
            field: 'room_no',
            headerName: 'Room No',
            width: 80,
            renderCell: (params) => {
                return params.row.room_no?.room_no || '';
            },
        },
        {
            field: 'surgeon',
            headerName: 'Surgeon',
            width: 80,
            renderCell: (params) => {
                return params.row.surgeon || '';
            },
        },
        {
            field: 'comments',
            headerName: 'Comments',
            width: 180,
            renderCell: (params) => {
                return params.row.comments || '';
            },
        },
        {
            field: 'update', headerName: 'Update Status',
            renderCell: (params) => (
                <Link to={`/ot-update/${params.row.id}/`} className="btn btn-info">
                    Update
                </Link>
            ),
            width: 150,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    OT List
                </h3>
                {ipViewData.length > 0 ? (
                    <div style={{height: 500, width: '100%'}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={ipViewData}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section>
    )
}
export default OtList;
